<div class="appliance-details-container">
  <!-- Address -->
  <div class="details-row">
    <div class="details-label">Address</div>
    <div class="details-value">{{ fullAddress }}</div>
  </div>

  <!-- Location Type -->
  <div class="details-row">
    <div class="details-label">Location Type</div>
    <div class="details-value">{{ locationType }}</div>
  </div>

  <!-- Contact Name and Phone together -->
  <div class="details-row">
    <div class="details-label">Contact Name</div>
    <div class="details-value contact-name-number">
      {{ contactName }}
      <ng-container *ngIf="contactPhone">
        <sn-icon class="phone-icon fa-solid fa-phone" size="xs"></sn-icon>
        <span class="phone-number">{{ contactPhone }}</span>
      </ng-container>
    </div>
  </div>

  <!-- Contact Email -->
  <div class="details-row">
    <div class="details-label">Contact Email</div>
    <div class="details-value">{{ contactEmail }}</div>
  </div>
</div>
